import { queryKeys, firstPageDefault } from "./types.js";
function getFilterString(searchString, changePaging = false, ...filters) {
  const searchParams = new URLSearchParams(searchString ?? "");
  if (filters) {
    filters.forEach((filter) => {
      if (filter.value !== void 0 && filter.value !== null && filter.value !== "") {
        const value = typeof filter.value === "string" ? filter.value : JSON.stringify(filter.value);
        searchParams.set(filter.key, value);
      } else {
        searchParams.delete(filter.key);
      }
    });
  }
  const page = searchParams.get(queryKeys.page);
  if (page && parseInt(page) !== 1 && changePaging) {
    searchParams.set(queryKeys.page, `${1}`);
  }
  const query = searchParams.toString();
  return query;
}
function getPagingString(searchString, paging) {
  const searchParams = new URLSearchParams(searchString ?? "");
  if (paging?.page) {
    searchParams.set(queryKeys.page, paging.page.toString());
  }
  if (paging?.pageSize) {
    searchParams.set(queryKeys.pageSize, paging.pageSize.toString());
  }
  const query = searchParams.toString();
  return query;
}
function toSearchFilter(query) {
  const searchParams = new URLSearchParams(query ?? "");
  const filters = [];
  let { page, pageSize } = firstPageDefault;
  let sort = [], order = [];
  let parsedValue = "";
  let selectedItemId = null;
  searchParams.forEach((value, key) => {
    switch (key) {
      case queryKeys.selectedItemId:
        selectedItemId = value;
        break;
      case queryKeys.page:
        page = parseInt(value);
        break;
      case queryKeys.pageSize:
        pageSize = parseInt(value);
        break;
      case queryKeys.sort:
        sort = value.split(",");
        break;
      case queryKeys.sortField:
        sort = value?.split(",");
        break;
      case queryKeys.order:
        order = value.split(",");
        break;
      case queryKeys.sortOrder:
        order = value?.split(",");
        break;
      default:
        try {
          parsedValue = JSON.parse(value);
        } catch {
          parsedValue = JSON.parse(JSON.stringify(value));
        }
        filters.push({ key, value: parsedValue });
        break;
    }
  });
  return {
    filter: filters,
    paging: { page, pageSize },
    sorting: sort.map(
      (s, i) => ({
        field: s,
        sort: order[i]
      })
    ),
    selectedItemId
  };
}
function appendQuery(pathname, query) {
  return query ? `${pathname}?${query}` : pathname;
}
function getSortString(searchString, sorting) {
  const searchParams = new URLSearchParams(searchString ?? "");
  if (sorting && sorting.length) {
    const sort = sorting.map((s) => s.field).join();
    const order = sorting.map((s) => s.sort).join();
    searchParams.set(queryKeys.sort, sort);
    searchParams.set(queryKeys.order, order);
  } else {
    searchParams.delete(queryKeys.sort);
    searchParams.delete(queryKeys.order);
  }
  const query = searchParams.toString();
  return query;
}
function getSelectedItemString(searchString, id) {
  const searchParams = new URLSearchParams(searchString ?? "");
  if (id) {
    searchParams.set(queryKeys.selectedItemId, id);
  }
  const query = searchParams.toString();
  return query;
}
function getSelectedItemId(search) {
  const searchParams = new URLSearchParams(search ?? "");
  return searchParams.get(queryKeys.selectedItemId);
}
function appendSelectedItemToQuery(pathname, id) {
  return appendQuery(pathname, getSelectedItemString("", id));
}
export {
  appendQuery,
  appendSelectedItemToQuery,
  getFilterString,
  getPagingString,
  getSelectedItemId,
  getSelectedItemString,
  getSortString,
  toSearchFilter
};
//# sourceMappingURL=utils.js.map
